module.exports = __webpack_public_path__ + "6bffe69ccce85a20933988a691f7b8d7.png";